import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 账户相关
const user = new Restful(project, 'user')

user.login = (data = {}) => {
  const url = project + 'user/login'
  return http.login(url, data).then(res => {
    return res
  })
}

user.logout = () => {
  const url = project + 'user/logout'
  return http.get(url).then(res => {
    return res
  })
}

user.register = (data = {}) => {
  const url = project + 'user/register'
  return http.register(url, data).then(res => {
    return res
  })
}

user.forget = (data = {}) => {
  const url = project + 'user/forget'
  return http.post(url, data).then(res => {
    return res
  })
}

user.reset = (data = {}) => {
  const url = project + 'user/reset'
  return http.put(url, data).then(res => {
    return res
  })
}

user.activation = (key = '') => {
  const url = project + 'user/activation'
  return http.get(url, { key }).then(res => {
    return res
  })
}

user.info = (data = {}) => {
  const url = project + 'user/info'
  return http.get(url, data).then(res => {
    return res
  })
}

user.password = (data = {}) => {
  const url = project + 'user/password'
  return http.put(url, data).then(res => {
    return res
  })
}

user.complete = (data = {}) => {
  const url = project + 'user/complete'
  return http.put(url, data).then(res => {
    return res
  })
}

user.authority = (id, data = {}) => {
  const url = project + 'user/' + id + '/authority'
  return http.get(url, data).then(res => {
    return res
  })
}

user.loginLog = (id, data = {}) => {
  const url = project + 'loginLog/' + id + '/user'
  return http.get(url, data).then(res => {
    return res
  })
}

user.resend = (type, data) => {
  const url = project + 'user/' + type + '/mail'
  return http.get(url, data).then(res => {
    return res
  })
}

user.setting = type => {
  const url = project + `user/setting/${type}`
  return http.get(url).then(res => {
    return res
  })
}
user.editSetting = (type, data) => {
  const url = project + `user/setting/${type}`
  return http.put(url, data).then(res => {
    return res
  })
}
user.validateEmail = (email, data) => {
  const url = project + `user/email/${email}`
  return http.get(url, data).then(res => {
    return res
  })
}
export default user
